module.exports = __webpack_public_path__ + "img/44.7959665e.png";